import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {NgForm} from '@angular/forms';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';

@Component({
  selector: 'app-student-profile',
  templateUrl: './questions-filter.component.html',
  styleUrls: ['./questions-filter.component.css']
})

export class QuestionsFilterComponent implements OnInit {
  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  extractedContent: any;
  questionInput: any;


  questionCounts = [5, 10, 15, 20];
  selectedQuestionCount: number;



  subjectsList: any = [];
  selectedSubject: any;
  selectedYear: any;
  selectedSemester: any;
  selectedTest: any;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";

  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;


  public papersList: any = [];
  public agg_question_list: any = [];
  public generatedQuestions: any = [];


  isLoading: boolean = false;

  errorMessage: string = '';
  displayErrorDialog: boolean = false;

  public typedText: string = '';
  private fullText: string = 'This is the text that will be typed!, Accessing well-structured question papers is crucial for students to excel in their academic pursuits. With carefully curated question papers, students gain the confidence to tackle examinations effectively, fostering a deeper understanding of subjects and enhancing their overall academic performance.';
  private currentIndex: number = 0;



  constructor(private dataAnalyticsService: DataAnalyticsService, private router: Router, private noticeboardService: NoticeboardService, private appConstants: AppConstants, private localStorage: LocalStorageService, private messageService: MessageService) {

    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve('Logo');
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve('id');
  }

  ngOnInit() {
    this.getLevelsName();
    this.getYearData();
    //----------------------------------
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');

    this.selectedQuestionCount = this.questionCounts[0];

  }

  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedSection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        try {
          // this.selectedSubject = this.subjectsList[0];
          // this.getPaperData();
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }


  onSelectedSubject(subject){
    this.agg_question_list = [];
    console.log("onSelectedSubject", subject);
    this.getPaperData();

  }


  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);

      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }








  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          // this.selectedGrade = mappedData[mappedData.length - 1];
          // this.getSectionByGrade(this.selectedGrade);
          // this.selectedSection = this.selectedGrade.Sections[0];
          // this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };


  getSectionByGrade(grade) {

    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
      this.getSubjects();
    } catch (error) {

    }
  }


  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    console.log('getGclClassesListById', section);
    this.getSubjects();
  }





  getYearList(year) {

    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
    //this.nameofstudent = [];
    //this.getClassSection()
    console.log(this.yearname)
    console.log(this.yearId)

    if (this.yearId && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
      this.getPaperData();
    }

  }




  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        this.yearId = this.YearData[0].YearId;
        console.log(this.yearId);
        try {
          // this.selectedYear = this.YearData[0];
        } catch (error) {

        }

        // console.log(response )
      }
    )
  }

  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          // this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          // this.getLevelClassSection(this.selectedlevel);

        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    console.log("fffff", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
    if (this.yearId && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
      this.getPaperData();
    }
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////


  changegrade() {
    console.log(this.selectedgrade)

  };
  changesection(){
    console.log(this.selectedsection)
  }


  find() {
    if (!this.questionInput) {
      this.showErrorDialog("Please insert question query!");
    }else{
      if (this.agg_question_list.length > 0) {
        let payload: any = {};
        payload.agg_question_list = this.agg_question_list;
        payload.no_questions = this.selectedQuestionCount;
        payload.user_query = this.questionInput

        console.log(payload);
        const apiCode = 'IIYAMFe4CAzOfgOKOHbEM8KffEbFjttLmOtY0XhOG4_vAzFufRu5uw==';

        this.isLoading = true; // Start loading


        this.dataAnalyticsService.filterPaper(payload,apiCode).finally(() => { }).subscribe(
          response => {
            this.isLoading = false; // Stop loading
            this.generatedQuestions = response['selected_questions'];
            console.log(this.generatedQuestions);
            if ((this.generatedQuestions.length) < this.selectedQuestionCount){
              this.showErrorDialog('These are all the available questions found');
            }
          },
          error => {
            console.log(error);
            this.isLoading = false; // Start loading
            this.messageService.add({
              severity: "error",
              summary: "Talkative Parents",
              detail: "Question filter failed",
            });
          }
        );
      }else{
        this.showErrorDialog("No papers found on this subject!");
      }
    }
  }



  showErrorDialog(message: string) {
    this.errorMessage = message;
    this.displayErrorDialog = true;
    this.isLoading = false;
    this.isSuccessful = 2;
  }



  onSelectedQuestionCount(value: number) {
    console.log('Selected Question Count:', value);
    // Additional logic here
  }


  formatContent(content: string): string[] {
    return content.split('\n');
  }



  private getPaperData() {
    this.isLoading = true;
    this.dataAnalyticsService.getPaper(this.yearId,this.yearId,this.selectedGrade.standardId,this.selectedSubject.SubjectId)._finally(() => {
      this.isLoading = false;
    }).subscribe(
      response => {
        console.log(response);
        this.papersList = response['Values'];
        if (this.papersList.length === 0) {
          this.showErrorDialog('No papers found on this subject');
        }
        // Mapping the response to a new array containing only the specified properties
        this.agg_question_list = this.papersList.map(item => ({
          question_list: JSON.parse(item.Content),
          year: item.AcademicYearName,
          grade: item.GradeName,
          source: item.PaperName,
          Term: item.SemesterName,
          subject_type: item.SubjectName,
        }));
        console.log(this.agg_question_list);
        },
      error => {
        this.isLoading = false; // Start loading
        console.error(error);
        if (this.agg_question_list.length === 0) {
          this.showErrorDialog('No papers found on this subject');
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/questions-filter/questions-filter.component.ts